const transitTransportModes = [
  "ferry",
  "bus",
  "tram",
  "tramlink",
  "train"
];
const isTransitLeg = ({ origin, destination, transportMode, transportModeName }) => !!((transitTransportModes.includes(transportMode == null ? void 0 : transportMode.mode) || transitTransportModes.includes(transportModeName)) && origin && destination);
var isTransitLeg_default = isTransitLeg;
export {
  isTransitLeg_default as default
};
